<template>
    <div>
        <div class="title-bar">
            <h1>{{ $t('wiki_view.title') }}</h1>
        </div>

        <DxDataGridSucesos :dxDataSourceProp="dxDataGridSource" :vistaWikiProp="true" />
    </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { onMounted, ref, watch } from 'vue';
import { useApi } from '@/.shared/.api/integration';
import type { DXLoadOptions, } from '@/.shared/.api';
import type CustomStore from 'devextreme/data/custom_store';
import DxDataGridSucesos from '@/components/sucesos/DxDataGridSucesos.vue';

const api = useApi();
const route = useRoute();
const dxDataGridSource = ref<CustomStore>();

onMounted(() => {
    dxDataGridSource.value = api.apiStore({
        key: "Id",
        load: async (opt: DXLoadOptions) => {
            return await api.callStandardApi("sucesoGetRejilla", { showLoading: false }, opt, undefined, true);
        }
    });
});
</script>